import { defineAsyncComponent } from 'vue'
export default {
  designdefault: defineAsyncComponent(() => import("/app/layouts/designdefault.vue").then(m => m.default || m)),
  designdefault2: defineAsyncComponent(() => import("/app/layouts/designdefault2.vue").then(m => m.default || m)),
  designdefault3: defineAsyncComponent(() => import("/app/layouts/designdefault3.vue").then(m => m.default || m)),
  designloginlayout: defineAsyncComponent(() => import("/app/layouts/designloginlayout.vue").then(m => m.default || m))
}